"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePushEvent = void 0;

var _pushEvent = require("./pushEvent");

var _postAnalytics = require("./postAnalytics");

var _withHandlePartialFailure = require("./withHandlePartialFailure");

var pushEvent = (0, _pushEvent.makePushEvent)((0, _withHandlePartialFailure.withHandlePartialFailure)(_postAnalytics.makePostAnalytics));
exports.makePushEvent = pushEvent;